import { isKilometerFactor } from "./transportEmissionFactorUnit";

type MappingFactor = {
  emission: number;
  denominatorUnit?: { id?: number | null } | null;
};

export type TransportMappingTotalEntry = {
  distance?: number | null;
  transportEmissionFactorEmission?: number | null;
  transportEmissionFactors: { emissionFactor: MappingFactor }[];
};

// km of a km mapping. Rows saved before the km rule have distance 0, so their km is read from the stored total.
export function kilometersOf(entry: TransportMappingTotalEntry, factor: MappingFactor): number {
  const distance = Number(entry.distance) || 0;
  if (distance > 0) return distance;

  const km = (Number(entry.transportEmissionFactorEmission) || 0) / factor.emission;
  return Number.isFinite(km) ? km : 0;
}

// Total emission of a saved emission-factor mapping: km × weight (kg) × emission for a km factor,
// the stored total for any other factor.
export default function calculateTransportMappingTotal(entry: TransportMappingTotalEntry, weightKg: number): number {
  const kilometerFactor = entry.transportEmissionFactors.map((x) => x.emissionFactor).find(isKilometerFactor);

  if (!kilometerFactor) return Number(entry.transportEmissionFactorEmission) || 0;

  return kilometersOf(entry, kilometerFactor) * weightKg * kilometerFactor.emission;
}
